import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading
  const [config, setConfig] = useState({});
  const [site, setSite] = useState({});

  const refreshSite = () => api.get("/settings/site").then((r) => setSite(r.data)).catch(() => {});

  useEffect(() => {
    api.get("/config").then((r) => setConfig(r.data)).catch(() => {});
    refreshSite();
    const token = localStorage.getItem("apex_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("apex_token");
        setUser(false);
      });
  }, []);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    localStorage.setItem("apex_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("apex_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("apex_token");
    setUser(false);
  };

  const refresh = async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch (e) {}
  };

  const approved = !!user && (user.role === "admin" || user.status === "approved");

  return (
    <AuthContext.Provider
      value={{ user, setUser, login, register, logout, refresh, config, site, refreshSite, approved, formatApiError }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
